import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  href,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl font-bold text-lg md:text-xl transition-all shadow-lg hover:shadow-xl active:scale-95';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-600 text-slate-900',
    secondary: 'bg-blue-900 hover:bg-blue-800 text-white'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const content = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-39">
      {children}
    </motion.button>;
  if (href) {
    return <a href={href} className={fullWidth ? 'w-full block' : 'inline-block'} data-id="element-40">
        {content}
      </a>;
  }
  return content;
}